import { useMutation, UseMutationOptions } from "react-query";
import { useRecoilValue } from "recoil";
import { toast } from "src/components";
import { authState } from "src/recoils";
import { UnlinkLine, UnlinkLineRequest, UnlinkLineResponse } from "src/services/customer/customer";

/**
 * Unlinks a customer's LINE connection. Kills every session for that
 * customer on every device — the caller is expected to confirm first.
 */
export function useUnlinkLine(
  options?: UseMutationOptions<UnlinkLineResponse, unknown, Omit<UnlinkLineRequest, "token">, unknown>
) {
  const { token = "" } = useRecoilValue(authState);
  return useMutation((request) => UnlinkLine({ token, ...request }), {
    onError: () => toast.error("ยกเลิกการเชื่อมต่อไลน์ไม่สำเร็จ"),
    onSuccess: () => toast.success("ยกเลิกการเชื่อมต่อไลน์สำเร็จ"),
    ...options,
  });
}
